export enum PROMO_QUERY_CLIENT {
  DESKTOP = 'DESKTOP',
  TABLET = 'TABLET',
  PHONE = 'PHONE',
  TV = 'TV'
}
